import { makeStyles } from '@material-ui/core/styles';

export const useMessageStyles = makeStyles(theme => ({
  messageRow: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2)
  },
  messageRowOutbound: {
    alignItems: 'flex-end'
  },
  messageRowInbound: {
    alignItems: 'flex-start'
  },
  messageBubble: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.spacing(2, 2, 0, 2),
    hyphens: 'auto',
    maxWidth: ({ messageFullWidth } = {}) => (messageFullWidth ? '100%' : '50%'),
    overflowWrap: 'break-word',
    padding: theme.spacing(2),
    whiteSpace: 'normal',
    wordWrap: 'break-word',

    [theme.breakpoints.down('sm')]: {
      maxWidth: '60%'
    }
  },
  responseContainer: {
    hyphens: 'auto',
    maxWidth: ({ messageFullWidth } = {}) => (messageFullWidth ? '100%' : '80%'),
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    wordWrap: 'break-word',

    [theme.breakpoints.down('sm')]: {
      maxWidth: '70%'
    }
  },
  responseContainerLatest: {
    minHeight: 'calc(100dvh - 250px)'
  },
  messageText: {
    color: theme.palette.common.white,
    whiteSpace: 'pre-wrap'
  },
  assistantTypography: {
    fontSize: 16,
    lineHeight: 1.5,

    '& p, & li, & span, & div': {
      fontSize: 16
    },

    '& h1': {
      fontSize: 22,
      lineHeight: 1.5,
      marginTop: theme.spacing(3)
    },

    '& h2': {
      fontSize: 20,
      lineHeight: 1.5,
      marginTop: theme.spacing(2)
    },

    '& h3': {
      fontSize: 18,
      lineHeight: 1.5,
      marginTop: theme.spacing(1.5)
    },

    '& h4, & h5, & h6': {
      fontSize: 16,
      lineHeight: 1.5,
      marginTop: theme.spacing(1)
    },

    '& pre': {
      maxWidth: '100%',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      overflowX: 'auto'
    },

    '& pre code': {
      whiteSpace: 'inherit',
      wordBreak: 'inherit'
    }
  },
  skeletonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minWidth: 300,
    width: '100%'
  },
  animatedLoaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(2, 0),
    gap: theme.spacing(1)
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    animation: '$pulse 1.4s ease-in-out infinite',
    boxShadow: `0 2px 8px ${theme.palette.primary.main}40`,
    '&:nth-child(1)': {
      animationDelay: '0s'
    },
    '&:nth-child(2)': {
      animationDelay: '0.2s'
    },
    '&:nth-child(3)': {
      animationDelay: '0.4s'
    }
  },
  '@keyframes pulse': {
    '0%, 80%, 100%': {
      opacity: 0.3,
      transform: 'scale(1)'
    },
    '40%': {
      opacity: 1,
      transform: 'scale(1.3)'
    }
  }
}));
